import React, { useContext } from 'react'
import GeoContext from 'contexts/geoContext'
import { LUXURY_ESCAPES } from 'constants/brands'
import config from 'constants/config'
import HeadData from 'components/Common/HeadData'

const headTitle = config.BRAND === LUXURY_ESCAPES ? 'Luxury Tours' : 'Tours'

function TourHeadData() {
  const { currentRegionCode } = useContext(GeoContext)
  return <HeadData title={`${headTitle} - ${config.title} ${currentRegionCode}`} />
}

export default TourHeadData
